module.exports = __webpack_public_path__ + "img/Group 22.e0f1cb4c.svg";